import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-barcode-frame",
  "use": "icon-barcode-frame-usage",
  "viewBox": "0 0 24 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 16\" id=\"icon-barcode-frame\"><path d=\"M4 12V4h2v8zm12 0V4h2v8zm-9 0V4h1v8zm2 0V4h2v8zm3 0V4h1v8zm2 0V4h1v8zm5 0V4h1v8zM18 2h4v4h2V0h-6zM2 6V2h4V0H0v6zm4 8H2v-4H0v6h6zm16-4v4h-4v2h6v-6z\" fill=\"#498de5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol